import Button from './ui/Button'
import React from 'react'
import ModalComponent from './Modal'

const CompactSuccessModal = ({ success, setSuccess, overlayZIndex = 1500 }) => {
    const title = typeof success === 'object' ? success?.title : 'Success'
    const message = typeof success === 'object' ? success?.message : success
    const tone = typeof success === 'object' ? success?.tone : 'success'

    return (
        <ModalComponent
            showModal={!!success}
            setShowModal={(next) => { if (!next) setSuccess(null) }}
            customMaxWidth='300px'
            customContentStyle={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                minWidth: 0,
                width: 'min(300px, calc(100vw - 32px))',
                padding: 0,
                overflow: 'hidden',
                transform: 'translate(-50%, -50%)',
            }}
            customOverlayStyle={{ zIndex: overlayZIndex }}
        >
            <div className='timesheetSuccessPage recordSuccessPage'>
                <div className='timesheetSuccessContent'>
                    <div className='timesheetSuccessIcon' aria-hidden='true' style={tone === 'warning' ? { background: '#fef3c7', color: '#92400e' } : tone === 'info' ? { background: '#dbeafe', color: '#1e40af' } : undefined}>
                        <svg viewBox='0 0 24 24'>
                            {tone === 'warning' ? <path d='M12 5v9m0 4v1' /> : tone === 'info' ? <path d='M12 10v9m0-14v1' /> : <path d='M5 12.5l4.2 4.2L19 7' />}
                        </svg>
                    </div>
                    <h2>{title || 'Success'}</h2>
                    <p>{message}</p>
                </div>
                <div className='timesheetSuccessFooter'>
                    <Button variant="secondary" size="md" onClick={() => setSuccess(null)}>OK</Button>
                </div>
            </div>
        </ModalComponent>
    )
}

export default CompactSuccessModal
